import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class DesignerLinkService {
  private readonly auth = inject(AuthService);

  /**
   * mode=design — Merchant editando su propio sitio (plan-gating activo).
   * Abre el site builder para la org dada.
   */
  openDesigner(orgId?: string, storageSignature?: string): void {
    const url = this.buildDesignerUrl(orgId, storageSignature);
    if (url) window.open(url, '_blank');
  }

  buildDesignerUrl(orgId?: string, storageSignature?: string): string | null {
    const token = this.auth.getToken();
    if (!token) return null;
    const org = orgId ?? this.auth.user()?.orgId ?? '';
    if (!org) return environment.storefrontUrl;
    const sigParam = storageSignature ? `&storageSignature=${btoa(storageSignature)}` : '';
    return `${environment.storefrontUrl}?mode=design&orgId=${org}&token=${encodeURIComponent(token)}${sigParam}`;
  }

  /**
   * mode=designAdmin — Admin revisando un sitio de cliente.
   * Plan-gating desactivado: ve todas las variantes y packs desbloqueados.
   */
  openAdminPreview(orgId: string, storageSignature?: string): void {
    const url = this.buildAdminPreviewUrl(orgId, storageSignature);
    if (url) window.open(url, '_blank');
  }

  buildAdminPreviewUrl(orgId: string, storageSignature?: string): string | null {
    const token = this.auth.getToken();
    if (!token || !orgId) return null;
    const sigParam = storageSignature ? `&storageSignature=${btoa(storageSignature)}` : '';
    return `${environment.storefrontUrl}?mode=designAdmin&orgId=${orgId}&token=${encodeURIComponent(token)}${sigParam}`;
  }

  /**
   * mode=demoBuilder — Admin editando visualmente una plantilla global (cmGlobalTemplate).
   * No requiere orgId — usa templateId (id de la plantilla global) directamente.
   * Todo desbloqueado: todos los packs y variantes disponibles.
   */
  openDemoBuilder(templateId: string): void {
    const token = this.auth.getToken();
    if (!token || !templateId) return;
    const url = `${environment.storefrontUrl}?mode=demoBuilder&templateId=${templateId}&token=${encodeURIComponent(token)}`;
    window.open(url, '_blank');
  }
}
